import { ReactNode } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import { getComparedDatePeriod } from 'src/view/screens/ReportsScreen/helpers/reports';
import { salesPeriodStore } from 'src/view/screens/ReportsScreen/screens/SalesPeriod/store/salesPeriodStore';
import './style.scss';

interface IComparedPeriod {
  startDate: number;
  endDate: number;
  onlyYears?: boolean;
}

interface IProps {
  onGenerateReport: () => void;
  onExportReport: () => void;
  comparedPeriod?: IComparedPeriod;
  children?: ReactNode;
  exportLoader: boolean;
}

const ReportHeader = ({ onGenerateReport, onExportReport, comparedPeriod, children, exportLoader }: IProps) => {
  const renderComparedPeriod = (period: IComparedPeriod) => {
    const { startDate, endDate, onlyYears } = period;
    const [startComparedDate, endComparedDate] = getComparedDatePeriod(startDate, endDate, salesPeriodStore.filters.comparedPeriod, onlyYears);
    return <span>{`${startComparedDate} - ${endComparedDate}`}</span>;
  };

  return (
    <>
      <div className="d-flex justify-content-between report-header">
        <div className="d-flex">{children}</div>
        <div className="d-flex gap-10">
          <Button
            loading={exportLoader}
            appearance="secondary"
            onClick={onExportReport}
            className="report-header__btn"
            title={localeStore.t('export_to_excel')}
          />
          <Button title={localeStore.t('generate')} onClick={onGenerateReport} className="report-header__btn mr-4" />
        </div>
      </div>
      {comparedPeriod ? (
        <div className="report-header__compared-tip d-flex family-regular text-size-14 color-gray2">
          <p className="mr-1">
            {localeStore.t('compared_with')} {renderComparedPeriod(comparedPeriod)}
          </p>
        </div>
      ) : null}
    </>
  );
};

export default ReportHeader;
